import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VKAtgardLeveransvirkesvolymDTO } from "../../models/atgard-leveransvirkesvolym-models";
import { IVirkeskostnadPrimaryKey } from "../virkeskostnader/VirkeskostnadBaseCommand";

export class AtgardLeveransvirkesVolymCommandBase extends BasicCommand<AtgardLeveransvirkesVolymCommandBase> {
    readonly leveransvirkesvolym: VKAtgardLeveransvirkesvolymDTO;
    kontraktGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Leveransvirkesvolym";

    get primaryKey(): IAtgardLeveransvirkesVolymPrimaryKey {
        return {
            atgardGuid: undefined, // Virkeskostnadnyckel för leveransvirke är kopplats till kontrakt enbart
            virkeskopsatgardLeveransvirkeGuid: this.leveransvirkesvolym.virkeskopsatgardLeveransvirkeGuid,
            guid: this.leveransvirkesvolym.virkeskostnadGuid,
            kontraktGuid: this.kontraktGuid
        };
    }

    constructor(leveransvirkesvolym: VKAtgardLeveransvirkesvolymDTO, type: string, commandType: CommandType) {
        super(type, AtgardLeveransvirkesVolymCommandBase.$groupKey, commandType);
        this.leveransvirkesvolym = leveransvirkesvolym;
    }
}

interface IAtgardLeveransvirkesVolymPrimaryKey extends IVirkeskostnadPrimaryKey {
    virkeskopsatgardLeveransvirkeGuid: string;
}
